// import React from "react";
// import Masthead from "../components/sections/homepage/Masthead";
// import Empower from "../components/sections/homepage/Empower";
// import Advantage from "../components/sections/homepage/Advantage";
// import Features from "../components/sections/homepage/Features";
// import Solution from "../components/sections/homepage/Solution";
// import Layout from "../components/layout/Layout";
import { useExperiment } from "@statsig/react-bindings";
import EnterpriseOne from "./EnterpriseOne";
import EnterpriseTwo from "./EnterpriseTwo";

export const Homepage = () => {
  const { value } = useExperiment("homepage_template_test");
  const variant = value?.template ?? "template-a";

  return variant === "template-a" ? <EnterpriseOne /> : <EnterpriseTwo />;
  // return (
  //   <Layout title="HPE Hybrid Cloud">
  //     <Masthead />
  //   </Layout>
  // );
};
